<template>
  <section class="transfer">
    <div class="mt-0" style="font-size: 20px; text-align:  center; padding-top: 0" v-html="$t('wallet.ln_42')"></div>
    <template v-if="tokens.length > 0">
      <hooper :settings="settings">
        <slide v-for="(item, index) in tokens" :key="index" :index="index">
          <template v-if="item.append">
            <router-link :to="{ path: '/wallet/tokens'}">
              <div class="slide-item dashed">
                <i class="far fa-plus-circle"/>
              </div>
            </router-link>
          </template>
          <template v-else>
            <div @click="item.default ? reset() : tokenToggle(item.contract)" class="slide-item">
              <div class="text-center">
                <b-avatar badge-variant="info" class="mr-2" variant="default" :text="item.name | namegr" size="3rem">
                  <template v-if="item.default" #badge><i class="far fa-star"/></template>
                </b-avatar>
                <p class="mt-2">{{ item.name }}</p>
              </div>
              <div class="text-center">
                <i class="fal fa-wallet"/> <b>{{ item.value }}</b> <b>{{ item.symbol }}</b>
              </div>
            </div>
          </template>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </hooper>
    </template>
    <b-row class="mt-4">
      <b-col/>
      <b-col lg="12">
          <b-row class="text-center">
            <b-col lg="3" >
              <b-card no-body class="text-center mb-2" style="box-shadow: none; background-color:#4A4CB0;  color:#ffffff" >
                <b-card-text class="p-2">
                  <b>{{ $t('wallet.ln_5') }}:</b>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col lg="9" >
              <b-card no-body class="text-center mb-2" style="box-shadow: none;  background-color: #f0f2f9" >
                <b-card-text class="p-2">
                  <b>{{ transfer.balance }} {{ transfer.symbol }}</b>
                </b-card-text>
              </b-card>

            </b-col>

            <b-col lg="3" >
              <b-card no-body class="text-center mb-2" style="box-shadow: none; background-color:#4A4CB0; color:#ffffff" >
                <b-card-text class="p-2">
                  <b>{{ $t('wallet.ln_4') }}:</b>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col lg="9" >
              <b-input-group class="mb-2 text-center" >
                <b-form-input v-model="transfer.to" :placeholder="$t('wallet.ln_40')" style="box-shadow: none; border-color: #f0f2f9; background-color: #f0f2f9"/>
              </b-input-group>
            </b-col>

            <b-col lg="3" >
              <b-card no-body class="text-center mb-2" style="box-shadow: none; background-color:#4A4CB0; color:#ffffff" >
                <b-card-text class="p-2">
                  <b>{{ $t('wallet.ln_3') }}:</b>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col lg="9" >
              <b-input-group class="mb-2 text-center">
                <b-form-input v-model="transfer.value" :placeholder="$t('wallet.ln_41')" style="box-shadow: none; border-color: #f0f2f9; background-color: #f0f2f9"/>
              </b-input-group>
            </b-col>
          </b-row>
        <b-row v-if="!transfer.contract">
          <b-col lg="3" >
            <b-card no-body class="text-center mb-2" style="box-shadow: none; background-color:#4A4CB0; color:#ffffff" >
              <b-card-text class="p-2">
                <b>{{ $t('wallet.ln_43') }}:</b>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="3">
            <b-card no-body :bg-variant="transfer.gas === 21000 ? 'primary' : 'light'" class="cursor-pointer text-center mb-3 " style="box-shadow: none" >
              <b-card-text class="p-2" @click="onGas(21000)">
                <i class="fal fa-tachometer-alt-slow"/> <small>Standart</small> <b>21000</b>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="3">
            <b-card no-body :bg-variant="transfer.gas === 31000 ? 'primary' : 'light'" class="cursor-pointer text-center mb-3" style="box-shadow: none">
              <b-card-text class="p-2" @click="onGas(31000)">
                <i class="fal fa-tachometer-alt-average"/> <small>Light</small> <b>31000</b>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="3">
            <b-card no-body :bg-variant="transfer.gas === 41000 ? 'primary' : 'light'" class="cursor-pointer text-center mb-3" style="box-shadow: none">
              <b-card-text class="p-2" @click="onGas(41000)">
                <i class="fal fa-tachometer-alt-fastest"/> <small>Hight</small> <b>41000</b>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <div v-if="transfer.safe">
          <hr>
          <b-row class="text-center">
            <b-col lg="3" >
              <b-card no-body class="text-center mb-2" style="box-shadow: none; background-color:#4A4CB0; color:#ffffff" >
                <b-card-text class="p-2" style="font-size: 14px">
                  <b>{{ $t('wallet.ln_21') }}:</b>
                </b-card-text>
              </b-card>
            </b-col>
            <b-col lg="9">
          <vie-otp-input v-if="transfer.render" input-type="password" @on-complete="invalue" input-classes="form-control text-center" :num-inputs="4" separator="&nbsp;&nbsp;" />
              </b-col>
            <b-col lg="12">
          <b-form-text class="mb-2" id="pincode-help-block" >
            ({{ $t('wallet.ln_19') }})
          </b-form-text>
            </b-col>
          </b-row>
        </div>
        <b-button class="w-100 mb-5 " @click="setTransaction" variant="outline-primary">
          <b-spinner v-if="delay" small/>
          {{ $t('wallet.ln_2') }} <i v-if="transfer.safe" class="fal fa-check-circle"/></b-button>
        <div class="clearfix mb-3"></div>
      </b-col>
      <b-col/>
    </b-row>
    <section v-if="contacts.length > 0" class="contacts">

      <b-row>
        <b-col v-for="item in contacts" :key="item.id" lg="2">
          <template v-if="delay">
            <b-card class="text-center mt-4">
              <b-card-text>
                <b-skeleton type="avatar" style="margin: 0 auto;"/>
              </b-card-text>
              <template v-slot:footer>
                <b-skeleton width="100%"/>
              </template>
            </b-card>
          </template>
          <template v-else>
            <b-card @click="getTo(item.address)" class="hover text-center mt-4">
              <b-card-text>
                <b-avatar v-b-tooltip.hover :title="item.name ? item.name : item.address" variant="default" :src="item.image" :text="item.name | namegr" size="3rem"/>
              </b-card-text>
            </b-card>
          </template>
        </b-col>
      </b-row>
      <b-button v-if="more.show" @click="getMore" class="w-100 mt-4" variant="light">
        <b-spinner v-if="more.loading" small/>
        <i v-else class="fas fa-angle-down text-info"></i>
      </b-button>
    </section>
  </section>
</template>

<script lang="js">

import Vue from 'vue'
import axios from 'axios';
import api from '../../libs/api';
import VieOtpInput from '@bachdgvn/vue-otp-input';
import VueClipboard from 'vue-clipboard2';
import {Hooper, Navigation as HooperNavigation, Pagination as HooperPagination, Slide} from 'hooper';
import 'hooper/dist/hooper.css';

Vue.use(VueClipboard)

const symbol = "EVC";

export default {
  name: "wallet.transfer",
  components: {
    'vie-otp-input': VieOtpInput,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  data() {
    return {
      from: null,
      settings: {
        itemsToShow: 3,
        centerMode: false,
        infiniteScroll: false,
        breakpoints: {
          2400: {
            itemsToShow: 4
          },
          1800: {
            itemsToShow: 3
          },
          1500: {
            itemsToShow: 3
          },
          1100: {
            itemsToShow: 3
          },
          0: {
            itemsToShow: 1
          }
        }
      },
      contact: {
        id: null,
        address: null,
        name: null,
        image: null
      },
      contacts: [],
      more: {
        show: false,
        loading: false
      },
      delay: false,
      count: 0,
      transfer: {
        balance: 0,
        from: null,
        to: null,
        value: null,
        pincode: null,
        safe: false,
        render: true,
        contract: null,
        symbol: symbol,
        gas: 21000
      },
      token: {
        value: 0,
        contract: null,
        name: null,
        symbol: null,
        default: false,
        append: false
      },
      default: [],
      tokens: []
    }
  },
  metaInfo() {
    return {
      title: 'Wallet - Transfer'
    }
  },
  mounted() {
    this.getTokens();
    this.getCheck();
    this.getBalance();
    this.getContact(0);
    this.getBlockHeader();
  },
  methods: {
    invalue(pincode) {
      this.$data.transfer.pincode = pincode
    },
    reset() {
      this.$data.transfer.symbol = symbol;
      this.$data.transfer.contract = null;
      this.$data.transfer.to = null;
      this.$data.transfer.value = null;
      this.$data.transfer.pincode = null;
      this.$data.transfer.render = false;
      this.$data.transfer.gas = 21000;
      this.$nextTick(() => {
        this.$data.transfer.render = true;
      });
      this.getBalance();
      this.getBlockHeader();
    },
    onCopy() {
      this.$bvToast.toast(`${this.$t('success.ln_5')}`, {
        title: this.$t('success.ln_3'),
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
        variant: 'info',
      });
    },
    onGas(gas) {
      this.$data.transfer.gas = gas;
    },
    getBlockHeader() {
      if (!this.$data.transfer.contract) {
        this.$web3.eth.subscribe('newBlockHeaders', (error) => {
          if (error) return this.$log.info(error);
          this.getBalance();
        });
      }
    },
    getTo(address) {
      this.$data.transfer.to = address;
    },
    getMore() {
      this.getContact(this.$data.contacts[this.$data.contacts.length - 1].id);
    },
    tokenToggle(contract) {
      let index = this._.findKey(this.$data.tokens, {contract: contract});
      this.$data.transfer.symbol = this.$data.tokens[index].symbol;
      this.$data.transfer.balance = this.$data.tokens[index].value;
      this.$data.transfer.contract = this.$data.tokens[index].contract;
    },
    getTokens() {
      axios.post(api.wallet.tokenToggle).then((response) => {

        this.$data.tokens = [];

        if (response.data.tokens !== undefined) {

          for (let i = 0; i < response.data.tokens.length; i++) {

            this.$data.token.value = response.data.tokens[i].value ? response.data.tokens[i].value : "0.00000000";
            this.$data.token.contract = response.data.tokens[i].contract;
            this.$data.token.name = response.data.tokens[i].name;
            this.$data.token.symbol = response.data.tokens[i].symbol;

            this.$data.tokens.push(Object.assign({}, this.$data.token));

          }

          this.getDefault();
        }
      });
    },
    getContact(last) {

      if (last) {
        this.$data.more.loading = true;
      } else {
        this.$data.delay = true;
      }

      axios.post(api.contact.get, {transposal: true, last: last, limit: 18}).then(async (response) => {

        if (!last) {
          this.$data.contacts = [];
        }

        if (response.data.source !== undefined) {
          this.$data.count = response.data.count;
          for (let i = 0; i < response.data.source.length; i++) {

            await this.$storage("account", response.data.source[i].address, response.data.source[i].image).then((response) => {
              this.$data.contact.image = response;
            });

            this.$data.contact.id = response.data.source[i].id;
            this.$data.contact.address = response.data.source[i].address;
            this.$data.contact.name = response.data.source[i].name;

            this.$data.contacts.push(Object.assign({}, this.$data.contact));
          }
          this.$data.more.show = this.$data.count > this.$data.contacts.length;
        } else {
          this.$data.more.show = false;
        }

        if (last) {
          this.$data.more.loading = false;
        } else {
          this._.delay(() => {
            this.$data.delay = false;
          }, 1000)
        }

      });
    },
    getCheck() {
      axios.post(api.wallet.check).then((response) => {
        this.$data.transfer.safe = response.data.safe;
      });
    },
    setTransaction() {
      this.$data.delay = true;
      if (this.$data.transfer.to && this.$data.transfer.value && this.$data.transfer.value > 0) {
        axios.post(api.wallet.transaction, {
          to: this.$data.transfer.to,
          value: this.$data.transfer.value,
          pincode: this.$data.transfer.pincode,
          safe: this.$data.transfer.safe,
          contract: this.$data.transfer.contract,
          gas: this.$data.transfer.gas
        }).then(() => {

          let index = this._.findKey(this.$data.tokens, {contract: this.$data.transfer.contract});
          if (index !== undefined) {
            this.$data.tokens[index].value = this.$data.tokens[index].value - this.$data.transfer.value;
          }

          this.reset();

          this.$data.delay = false;
          this.$bvToast.toast(`${this.$t('success.ln_5')}`, {
            title: this.$t('success.ln_3'),
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            variant: 'info',
          });

        }).catch((error) => {
          this.$data.delay = false;
          this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
            title: this.$t('error.ln_5'),
            autoHideDelay: 5000,
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
          });
        });
      } else {
        this.$data.delay = false;
        this.$bvToast.toast(`${this.$t('error.ln_7')}`, {
          title: this.$t('error.ln_5'),
          autoHideDelay: 5000,
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
        });
      }
    },
    getDefault() {
      this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
        if (account) {
          this.$web3.eth.getBalance(account.address).then((balance) => {
            this.$data.transfer.balance = Number(this.$web3.utils.fromWei(balance, 'ether')).toFixed(8);

            this.$data.token.value = this.$data.transfer.balance;
            this.$data.token.contract = false;
            this.$data.token.name = "Evrice Coin";
            this.$data.token.symbol = symbol;
            this.$data.token.default = true;
            this.$data.token.append = false;

            this.$data.tokens.push(Object.assign({}, this.$data.token));

            this.$data.token.value = 0;
            this.$data.token.contract = false;
            this.$data.token.name = null;
            this.$data.token.symbol = null;
            this.$data.token.default = false;
            this.$data.token.append = true;

            this.$data.tokens.push(Object.assign({}, this.$data.token));

          });
        }
      });
    },
    getBalance() {
      this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
        if (account) {
          this.$data.transfer.from = account.address;
          this.$web3.eth.getBalance(account.address).then((balance) => {
            this.$data.transfer.balance = Number(this.$web3.utils.fromWei(balance, 'ether')).toFixed(8);
            let index = this._.findKey(this.$data.tokens, {default: true});
            if (index !== undefined) {
              this.$data.tokens[index].value = this.$data.transfer.balance;
            }
          });
        }
      });
    }
  }
}
</script>

<style scoped>

.contacts {
  background-color: #fafbff;
  border-top: 1px solid #f0f2f9;
  margin: 20px -20px 0 -20px;
  padding: 0 20px 20px 20px;
}

.contacts .hover {
  background-color: white;
}

.contacts .hover:hover {
  background-color: #c9d0ff;
}

.hooper-next, .hooper-prev {
  top: 42% !important;
}

.bg-primary {
  color: white !important;
  background-color: #4A4CB0 !important;
  transition: 0.4s;
}

</style>
